/*
 * Lightweight utility for keeping track of API responses
 */
import { AxiosError, AxiosResponse } from 'axios'

import { ScanResult } from '../services/client/Lookup'

type AxiosResult = AxiosError | AxiosResponse

export class ScanCache {
  cache: { [ident: string]: [ScanResult?, AxiosResult?] }

  constructor() {
    this.cache = {}
  }

  get = (ident: string) => {
    return this.cache[ident]
  }

  store = (ident: string, response: [ScanResult?, AxiosResult?]) => {
    this.cache[ident] = response
  }

  clear = (ident: string) => {
    delete this.cache[ident]
  }
}
